import classNames from 'classnames';
import * as React from 'react';
const ListItemLabel = (props) => {
    const { prefix = 'cn-ui-m-', className, children, ...others } = props;
    return (React.createElement("div", { ...others, className: classNames(`${prefix}list-item-title`, className) }, children));
};
export default ListItemLabel;
